const authFinishPath = "/auth/finish";

/**
 * The OAuth callback url is fixed and carries no query: anna-auth matches it against a per-client
 * allowlist and compares it byte for byte between the authorize request and the token exchange.
 */
export const createAuthCallbackUrl = (origin: string): URL => new URL(authFinishPath, origin);
